import { ThemeSelectors } from '@at/design-system-foundation'
import styled from 'styled-components'

interface SaveAdvertButtonProps {
    save?: boolean
}

export const NewStyledSaveAdvertButton = styled.button<SaveAdvertButtonProps>`
    &:disabled {
        svg {
            fill: currentColor;
        }
        &:hover {
            color: ${({ theme }) => theme.color.button.bgFill.disabled};
        }
        background-color: ${({ theme }) => theme.color.button.bgFill.contrast.active};
        color: ${({ theme }) => theme.color.button.bgFill.disabled};
    }
    &:hover {
        color: ${({ theme }) => theme.color.icon.critical};
        cursor: pointer;
    }
    svg {
        &:hover {
            ${({ theme, save }) => (save ? `fill: ${theme.color.icon.save}` : `fill: currentColor;`)}
        }
        cursor: pointer;
        display: inline-block;
        height: 14px;
        vertical-align: middle;
        width: 14px;
        ${({ theme, save }) => (save ? `fill: ${theme.color.icon.save}` : `fill: currentColor`)};
    }
    position: absolute;
    height: 34px;
    width: 34px;
    top: 5%;
    right: 4%;
    border-radius: 100%;
    background: ${({ theme }) => theme.color.button.bgFill.contrast.active};
    color: ${({ theme }) => theme.color.icon.save};
    padding: 10px;
    border: none;
    z-index: 4;
    display: flex;
    box-shadow: ${({ theme }) => ThemeSelectors.getShadowFive(theme)};
`
